/**
 * Created by rickborst on 24/04/2017.
 */

const ImageTypes = {
    collage: 'collage',
    responsive: 'responsive'
}, LandingPageTypes = {
    general: 'general',
    match: 'match',
    magazine: 'magazine'
};

class LandingPage {

    /**
     * Constructs the model.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {

        this.notMeText =  options.notMeText || '';
        this.callToAction =  options.callToAction || null;
        this.register =  options.register || null;
        this.belowRegisterAnonymous =  options.belowRegisterAnonymous || null;
        this.collage =  options.collage || null;
        this.devices =  options.devices || null;
        this.faq =  options.faq || [];
        this.landingPages =  options.landingPages || [];

        return this;
    }

    /**
     * Returns current landing page according to its start and end time.
     *
     * @return {Object} - Current landing page.
     */
    getCurrentLandingPage () {
        let i, j, currentLandingPage,
            currentTime = Math.floor(new Date().getTime() / 1000);

        for (i = 0, j = this.landingPages.length; i < j; i++) {
            let lp = this.landingPages[i];

            if (lp.startTime < currentTime && lp.endTime > currentTime) {
                currentLandingPage = lp;
            }
        }
        
        if (!currentLandingPage) {
            currentLandingPage = this.getGeneralLandingPage();
        }

        return currentLandingPage;
    }

    /**
     * Returns general landing page.
     *
     * @return {Object} - General landing page.
     */
    getGeneralLandingPage () {
        let i, j, generalLandingPage;

        for (i = 0, j = this.landingPages.length; i < j; i++) {
            if (this.landingPages[i].type === LandingPageTypes.general) {
                generalLandingPage = this.landingPages[i];
                break;
            }
        }

        return generalLandingPage;
    }

}

export default LandingPage;
export {ImageTypes, LandingPageTypes};


// WEBPACK FOOTER //
// ./src/js/models/landingpage.js